<script>
    import ComboSelect from '../ComboSelect/ComboSelect.svelte';
    import TextInput from '../TextInput.svelte';
    import PasswordInput from '../Form/inputs/PasswordInput.svelte';
    import DuplicateCheckTextInput from '../DuplicateCheckTextInput.svelte';
    import CheckBox from '../CheckBox.svelte';

    export let schema = null;
    export let fields = [];
    export let id = 'basicForm';
    export let formModel = {};
</script>

<form>
    {#each Object.keys(fields) as key}
        <div {id} class="form-group">
            {#if fields[key].type === 'select'}
                <ComboSelect
                    id={key}
                    label={fields[key].label}
                    bind:options={fields[key].options}
                    children={fields[key].children}
                    bind:value={formModel[key]}
                    bind:isValid={fields[key].isValid}
                    bind:errors={fields[key].errors}
                    on:changed={fields[key].hasOwnProperty('handleChanged') ? fields[key].handleChanged : () => {}}
                    searchable={fields[key].searchable}
                    {schema} />
            {:else if fields[key].type === 'text'}
                {#if fields[key].duplicateCheck}
                    <DuplicateCheckTextInput
                        id={key}
                        apiurl={fields[key].duplicateCheckApi}
                        label={fields[key].label}
                        multiline={fields[key].multiline}
                        message={fields[key].message}
                        bind:value={formModel[key]}
                        bind:isValid={fields[key].isValid}
                        bind:errors={fields[key].errors}
                        on:check={fields[key].onCheck}
                        on:change={fields[key].hasOwnProperty('handleChanged') ? fields[key].handleChanged : () => {}}
                        {schema} />
                {:else}
                    <TextInput
                        id={key}
                        label={fields[key].label}
                        bind:isValid={fields[key].isValid}
                        bind:errors={fields[key].errors}
                        bind:value={formModel[key]}
                        object={formModel}
                        rows={fields[key].rows}
                        multiline={fields[key].multiline}
                        ignoreFieldLevelValidation="{fields[key].ignoreFieldLevelValidation}"
                        on:change={fields[key].hasOwnProperty('handleChanged') ? fields[key].handleChanged : () => {}}
                        {schema} />
                {/if}
            {:else if fields[key].type === 'checkbox'}
                <CheckBox
                    id={key}
                    label={fields[key].label}
                    bind:checked={formModel[key]}
                />
            {:else if fields[key].type === 'password'}
                <PasswordInput
                    id={key}
                    type="password"
                    object={formModel}
                    label={fields[key].label}
                    bind:isValid={fields[key].isValid}
                    bind:errors={fields[key].errors}
                    bind:value={formModel[key]}
                    on:change={fields[key].hasOwnProperty('handleChanged') ? fields[key].handleChanged : () => {}}
                    {schema} />
            {/if}
        </div>
    {/each}
</form>
